import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { createProvider } from './vue-apollo'
import { onError } from 'apollo-link-error'
import SentryService from '@/services/sentry.service'

Vue.config.productionTip = false

const link = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, path }) => {
      if (path && !path.includes('login')) {
        if (message === 'Not authorized') {
          store.state.app.showNotLoggedInModal = true
        } else {
          console.log(graphQLErrors)
          store.state.app.errorMessage = message
          store.state.app.showErrorModal = true
        }
      }
    })

  if (networkError) console.log(`[Network error]: ${networkError}`)
})

export const apolloProvider = createProvider({ link })

new Vue({
  router,
  store,
  vuetify,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')

SentryService.init()
